// import { Modal } from "./modal";
// import localScaleManager from "../../helpers/LocalScaleManager";
// import { Parser } from "../../helpers/parser";
// import reDealPlayer from "./objects/reDealPlayer";
// import { PieTimer } from "./objects/pieTimer";
// import Button from "./objects/button";
// import { Helpers } from "../../helpers/helpers";
// import { WebSocketManager } from "../../helpers/webSocketManager";
// import { tweenConfigs } from "../../helpers/tweensConfigs";
import { store } from "@/store/store";

// export class ReDealModal extends Modal {
export class ReDealModal {
  constructor(scene, table) {
    // super(scene, table);
    this.scene = scene;
    this.table = table;
    // this.isShowing = false;
    // this.reDealType = [];
    // this.timeRemaining = 0;
    // this.receivedOfferType = "";
    // this.bg = this.scene.add
    //   .sprite(0, 0, this.scene.atlasTexture, "re-deal-bg")
    //   .setOrigin(0);
    // this.table.poolArray.push(this.bg);

    // this.isOfferer = true;
    // this.boardCards = this.scene.add.group({
    //   key: "cards",
    //   repeat: 4,
    // });
    // this.table.poolArray.push(this.boardCards);

    // this.outsCards = this.scene.add.group({
    //   key: "cards",
    //   repeat: 15,
    // });
    // this.table.poolArray.push(this.outsCards);

    // this.boardCardsUpsideDown = this.scene.add.group({
    //   key: this.scene.atlasTexture,
    //   frame: "back-of-card",
    //   repeat: 4,
    // });
    // this.table.poolArray.push(this.boardCardsUpsideDown);

    // this.chipsTexture = "red-chips";
    // this.potValue = 300000;
    // this.textBox = this.scene.add
    //   .sprite(0, 0, this.scene.atlasTexture, "chip-text-box")
    //   .setOrigin(0)
    //   .setVisible(false);
    // this.table.poolArray.push(this.textBox);

    // this.text = this.scene.add.bitmapText(
    //   0,
    //   0,
    //   "myRaid",
    //   Parser.convertToXLetters(this.potValue.toLocaleString(), 11)
    // );
    // this.table.poolArray.push(this.text);
    // this.text.setData("width", this.text.width);
    // this.text.setData("height", this.text.height);

    // this.chips = this.scene.add
    //   .sprite(0, 0, this.scene.atlasTexture, this.chipsTexture)
    //   .setOrigin(0);
    // this.table.poolArray.push(this.chips);

    // this.selfPlayer = new reDealPlayer(
    //   this.scene,
    //   true,
    //   this.table.cardsType[0],
    //   this.table
    // );
    // this.otherPlayer = new reDealPlayer(
    //   this.scene,
    //   false,
    //   this.table.cardsType[0],
    //   this.table
    // );

    // this.timer = new PieTimer(scene, this.table);

    // this.outsText = this.scene.add.bitmapText(
    //   0,
    //   0,
    //   "myRaid",
    //   Parser.convertToXLetters("Outs: 24", 11)
    // );
    // this.table.poolArray.push(this.outsText);

    // this.outsText.setData("width", this.outsText.width);
    // this.outsText.setData("height", this.outsText.height);

    // this.runItTwiceBtn = new Button(
    //   this.scene,
    //   "run-it-twice-btn",
    //   true,
    //   this.table
    // ).on("pointerup", this.onRunItTwiceClicked, this); //D
    // this.runIt3TimesBtn = new Button(
    //   this.scene,
    //   "run-it-3-times-btn",
    //   true,
    //   this.table
    // ).on("pointerup", this.onRunIt3TimesClicked, this); //D
    // this.runIt2Of3Btn = new Button(
    //   this.scene,
    //   "run-it-2-of-3-btn",
    //   true,
    //   this.table
    // ).on("pointerup", this.onRunIt2Of3Clicked, this); //D
    // this.quitBtn = new Button(this.scene, "quit-btn", true, this.table).on(
    //   "pointerup",
    //   this.onQuitClicked,
    //   this
    // ); //D

    // this.acceptBtn = new Button(this.scene, "accept-btn", true, this.table).on(
    //   "pointerup",
    //   this.onAcceptClicked,
    //   this
    // ); //D
    // this.quit2Btn = new Button(this.scene, "quit-btn", true, this.table).on(
    //   "pointerup",
    //   this.onQuit2Clicked,
    //   this
    // ); //D
    // this.footerText = this.scene.add.bitmapText(
    //   0,
    //   0,
    //   "myRaid",
    //   Parser.convertToXLetters("Username23 Requested To Run It Twice", 45)
    // );
    // this.footerText.setData("width", this.footerText.width);
    // this.footerText.setData("height", this.footerText.height);
    // this.table.poolArray.push(this.footerText);

    // this.children = this.scene.add.group();
    // this.children.addMultiple([
    //   this.closeButton,
    //   ...this.boardCards.getChildren(),
    //   ...this.boardCardsUpsideDown.getChildren(),
    //   this.text,
    //   this.textBox,
    //   this.chips,
    //   ...this.selfPlayer.children,
    //   ...this.otherPlayer.children,
    //   ...this.timer.children.getChildren(),
    //   this.outsText,
    //   ...this.outsCards.getChildren(),
    //   this.runItTwiceBtn,
    //   this.runIt3TimesBtn,
    //   this.runIt2Of3Btn,
    //   this.quitBtn,
    //   this.acceptBtn,
    //   this.quit2Btn,
    //   this.footerText,
    //   this.bg,
    // ]);
    // this.table.poolArray.push(this.children);
    // Phaser.Actions.SetDepth(this.children.getChildren(), 101);
    // this.closeButton.setDepth(102); /* close button */
    // Phaser.Actions.SetAlpha(this.children.getChildren(), 0);
    // this.closeButton.on("pointerup", this.onCloseBtnClicked, this); //D
    // this.allowShow = true;
  }
  // onCloseBtnClicked() {
  //   this.closeButton.onClick(() => {
  //     this.closeButton.disableInteractive();
  //     if (this.isOfferer) {
  //       this.sendOfferReq("None")
  //         .then(() => {
  //           this.closeButton.enableInteractive();
  //         })
  //         .catch(() => {
  //           this.closeButton.enableInteractive();
  //         });
  //     } else {
  //       this.sendConfirmationReq(false)
  //         .then(() => {
  //           this.closeButton.enableInteractive();
  //         })
  //         .catch(() => {
  //           this.closeButton.enableInteractive();
  //         });
  //     }
  //   });
  // }
  hide() {
    this.scene.changeObjectsInteractivity(true);
    store.commit("setRedealVisibility", false);
    // return new Promise((resolve) => {
    //   this.scene.tweens.add({
    //     targets: this.children.getChildren(),
    //     duration: tweenConfigs.modal.hide.duration,
    //     ease: tweenConfigs.modal.hide.ease,
    //     alpha: 0,
    //     onComplete: () => {
    //       this.isShowing = false;
    //       this.allowShow = true;
    //       resolve();
    //     },
    //   });
    //   this.modalHide();
    // });
  }
  show(isOfferer) {
    this.scene.changeObjectsInteractivity(false);
    store.commit("setRedealVisibility", true);
    // this.changeModalType(isOfferer);
    // if (this.allowShow) {
    //   this.allowShow = false;
    //   // this.scene.getVisitedTable().buttonManager.raiseBtn.hideRaiseMenu();
    //   // this.scene.getVisitedTable().buttonManager.betBtn.hideRaiseMenu();
    //   this.timer.visibilityControls(true);
    //   this.isShowing = true;
    //   this.scene.tweens.add({
    //     targets: this.children.getChildren(),
    //     delay: 200,
    //     duration: tweenConfigs.modal.show.duration,
    //     ease: tweenConfigs.modal.show.ease,
    //     alpha: 1,
    //     // onComplete: () => {
    //     // }
    //   });
    //   this.timer.startTimer(this.timeRemaining ? this.timeRemaining : 10000);
    //   this.modalShow();
    // }
  }
  // showBoardCards(tableCards) {
  //   this.boardCards.children.iterate(function (card, i) {
  //     if (i < tableCards.length) {
  //       card.setTexture(
  //         "cards",
  //         Helpers.getCardsFrameByCode(tableCards[i].code)
  //       );
  //       card.setVisible(true);
  //       this.boardCardsUpsideDown.getChildren()[i].setVisible(false);
  //     } else {
  //       this.boardCardsUpsideDown.getChildren()[i].setVisible(true);
  //       card.setVisible(false);
  //     }
  //   }, this);
  // }
  // showOutsCards(cards) {
  //   this.outsCards.children.iterate(function (card, i) {
  //     if (i < cards.length) {
  //       card.setTexture("cards", Helpers.getCardsFrameByCode(cards[i].code));
  //       card.setVisible(true);
  //     } else {
  //       card.setVisible(false);
  //     }
  //   }, this);
  //   this.outsText.setText(
  //     Parser.convertToXLetters(`Outs: ${cards.length}`, 11)
  //   );
  // }
  // changeModalType(isOfferer) {
  //   this.isOfferer = isOfferer;
  //   if (this.isOfferer) {
  //     this.reDealType = this.table.tableInfo.reDealType;

  //     this.acceptBtn.setVisible(false);
  //     this.quit2Btn.setVisible(false);
  //     this.footerText.setVisible(false);

  //     this.runItTwiceBtn
  //       .setVisible(this.reDealType.find((t) => t === "Twice"))
  //       .enableInteractive();
  //     this.runIt3TimesBtn
  //       .setVisible(this.reDealType.find((t) => t === "Tripple"))
  //       .enableInteractive();
  //     this.runIt2Of3Btn
  //       .setVisible(this.reDealType.find((t) => t === "Iranian"))
  //       .enableInteractive();
  //     this.quitBtn.setVisible(true).enableInteractive();
  //   } else {
  //     this.acceptBtn.setVisible(true).enableInteractive();
  //     this.quit2Btn.setVisible(true).enableInteractive();
  //     this.footerText.setVisible(true);

  //     this.runItTwiceBtn.setVisible(false);
  //     this.runIt3TimesBtn.setVisible(false);
  //     this.runIt2Of3Btn.setVisible(false);
  //     this.quitBtn.setVisible(false);
  //   }
  // }
  updateInfo(gameState, isOfferer) {
    const redealInfo = {
      gameState: gameState,
      isOfferer: isOfferer
    }
    store.commit("setRedealInfo", redealInfo);
    store.commit("setTableInfo", this.table.tableInfo);
    // this.isOfferer = isOfferer;
    // this.timeRemaining = gameState.playerInfo.timeRemaining;

    // this.potValue = gameState.pot;
    // this.text.setText(
    //   Parser.convertToXLetters(this.potValue.toLocaleString(), 11)
    // );

    // this.showBoardCards(gameState.tablesCards);
    // this.showOutsCards(gameState.redealOuts);

    // this.selfPlayer.updateInfo(gameState.playerInfo);

    // const otherPlayerId = gameState.redealPlayers.find(
    //   (id) => id !== gameState.playerInfo.id
    // );
    // const otherPlayerInfo = gameState.otherPlayers.find(
    //   (player) => player.playerId === otherPlayerId
    // );
    // this.otherPlayer.updateInfo(otherPlayerInfo);

    // if (!this.isOfferer) {
    //   const offererUsername = otherPlayerInfo.username;
    //   let receivedOfferType = "";
    //   switch (gameState.redealType) {
    //     case "Twice":
    //       receivedOfferType = "Run It Twice";
    //       break;
    //     case "Tripple":
    //       receivedOfferType = "Run It 3 Times";
    //       break;
    //     case "Iranian":
    //       receivedOfferType = "Run It 2 of 3 Times";
    //       break;
    //   }
    //   this.footerText.setText(
    //     Parser.convertToXLetters(
    //       `${offererUsername} Requested To ${receivedOfferType}`,
    //       45
    //     )
    //   );
    // }
  }
  // onRunItTwiceClicked() {
  //   this.runItTwiceBtn.onClick(() => {
  //     this.runItTwiceBtn.disableInteractive();
  //     this.sendOfferReq("Twice")
  //       .then(() => {
  //         this.runItTwiceBtn.enableInteractive();
  //       })
  //       .catch(() => {
  //         this.runItTwiceBtn.enableInteractive();
  //       });
  //   });
  // }
  // onRunIt3TimesClicked() {
  //   this.runIt3TimesBtn.onClick(() => {
  //     this.runIt3TimesBtn.disableInteractive();
  //     this.sendOfferReq("Tripple")
  //       .then(() => {
  //         this.runIt3TimesBtn.enableInteractive();
  //       })
  //       .catch(() => {
  //         this.runIt3TimesBtn.enableInteractive();
  //       });
  //   });
  // }
  // onRunIt2Of3Clicked() {
  //   this.runIt2Of3Btn.onClick(() => {
  //     this.runIt2Of3Btn.disableInteractive();
  //     this.sendOfferReq("Iranian")
  //       .then(() => {
  //         this.runIt2Of3Btn.enableInteractive();
  //       })
  //       .catch(() => {
  //         this.runIt2Of3Btn.enableInteractive();
  //       });
  //   });
  // }
  // onQuitClicked() {
  //   this.quitBtn.onClick(() => {
  //     this.quitBtn.disableInteractive();
  //     this.sendOfferReq("None")
  //       .then(() => {
  //         this.quitBtn.enableInteractive();
  //       })
  //       .catch(() => {
  //         this.quitBtn.enableInteractive();
  //       });
  //   });
  // }

  // onQuit2Clicked() {
  //   this.quit2Btn.onClick(() => {
  //     this.quit2Btn.disableInteractive();
  //     this.sendConfirmationReq(false)
  //       .then(() => {
  //         this.quit2Btn.enableInteractive();
  //       })
  //       .catch(() => {
  //         this.quit2Btn.enableInteractive();
  //       });
  //   });
  // }
  // onAcceptClicked() {
  //   this.acceptBtn.onClick(() => {
  //     this.acceptBtn.disableInteractive();
  //     this.sendConfirmationReq(true)
  //       .then(() => {
  //         this.acceptBtn.enableInteractive();
  //       })
  //       .catch(() => {
  //         this.acceptBtn.enableInteractive();
  //       });
  //   });
  // }
  // sendOfferReq(type) {
  //   return new Promise((resolve, reject) => {
  //     WebSocketManager.emitEvent(
  //       {
  //         tableId: this.table.tableInfo.id,
  //         reDealType: type,
  //       },
  //       "poker.client-push.redeal-type"
  //     )
  //       .then(() => {
  //         this.hide().then(() => resolve());
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         reject();
  //       });
  //   });
  // }
  // sendConfirmationReq(status) {
  //   return new Promise((resolve, reject) => {
  //     WebSocketManager.emitEvent(
  //       {
  //         tableId: this.table.tableInfo.id,
  //         confirmation: status,
  //       },
  //       "poker.client-push.redeal-confirmation"
  //     )
  //       .then(() => {
  //         this.hide().then(() => resolve());
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //         reject();
  //       });
  //   });
  // }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  // positionControls(width, height, initX, initY) {
  //   const bgScale = localScaleManager.scaleSprite(
  //     this.bg,
  //     width,
  //     height,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.bg, bgScale);
  //   this.bg.setPosition(
  //     initX + (width - this.bg.displayWidth) / 2,
  //     initY + (height - this.bg.displayHeight) / 2
  //   );
  //   this.modalPositionControls(this.bg.x, this.bg.y, this.bg.displayWidth);

  //   const cardSize = width / 8;
  //   let cardWidth = 0;
  //   const cardScale = localScaleManager.scaleSprite(
  //     this.boardCards.getChildren()[0],
  //     cardSize,
  //     cardSize,
  //     0,
  //     1,
  //     true
  //   );
  //   this.boardCards.children.iterate(function (card, i) {
  //     localScaleManager.scaleSpriteTo(card, cardScale);
  //     localScaleManager.scaleSpriteTo(
  //       this.boardCardsUpsideDown.getChildren()[i],
  //       cardScale * 0.95
  //     );
  //     if (i === 0) {
  //       cardWidth = card.displayWidth * 0.85;
  //     }
  //     card.setPosition(
  //       initX +
  //         (width - cardWidth * 1.5) / 2 +
  //         i * (cardWidth + cardWidth / 4.5),
  //       initY + height / 5.8
  //     );
  //     this.boardCardsUpsideDown
  //       .getChildren()
  //       [i].setPosition(
  //         initX +
  //           (width - cardWidth * 1.5) / 2 +
  //           i * (cardWidth + cardWidth / 4.5),
  //         initY + height / 5.8
  //       );
  //   }, this);

  //   const chipsSize = width / 23;
  //   const chipsScale = localScaleManager.scaleSprite(
  //     this.chips,
  //     chipsSize,
  //     chipsSize,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.chips, chipsScale);
  //   this.chips.setPosition(initX + width / 2.34, initY + height / 4.2);

  //   const textSize = Math.min(width * 0.17, height * 0.17);
  //   localScaleManager.scaleBitMapText(
  //     this.text,
  //     textSize,
  //     textSize,
  //     Math.min(this.text.width, this.text.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.text.setPosition(
  //     this.chips.x + this.chips.displayWidth * 1.1,
  //     this.chips.y + this.chips.displayHeight / 5
  //   );

  //   const textBoxSize = textSize;
  //   const textBoxScale = localScaleManager.scaleSprite(
  //     this.textBox,
  //     textBoxSize,
  //     textBoxSize,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.textBox, textBoxScale);
  //   this.textBox.setPosition(
  //     this.text.x + (this.text.width - this.textBox.displayWidth) / 2,
  //     this.text.y + (this.text.height - this.textBox.displayHeight) / 2
  //   );

  //   this.selfPlayer.positionControls(
  //     width,
  //     height,
  //     initX + width / 5.2,
  //     initY + height / 3.15
  //   );
  //   this.otherPlayer.positionControls(
  //     width,
  //     height,
  //     initX + width / 1.5,
  //     initY + height / 3.15
  //   );
  //   this.timer.positionControls(
  //     this.bg.displayWidth / 13,
  //     this.bg.x + this.bg.displayWidth / 2,
  //     this.bg.y + height / 2.6
  //   );

  //   const outsTextSize = Math.min(width * 0.17, height * 0.17);
  //   localScaleManager.scaleBitMapText(
  //     this.outsText,
  //     outsTextSize,
  //     outsTextSize,
  //     Math.min(this.outsText.width, this.outsText.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.outsText.setPosition(initX + width / 9, this.bg.y + height / 2.35);

  //   this.outsCards.children.iterate(function (card, i) {
  //     localScaleManager.scaleSpriteTo(card, cardScale);
  //     if (i === 0) {
  //       cardWidth = card.displayWidth * 0.85;
  //     }
  //     card.setPosition(
  //       initX +
  //         width / 6 +
  //         (i < 8
  //           ? i * (cardWidth + cardWidth / 4.5)
  //           : (i - 8) * (cardWidth + cardWidth / 4.5)),
  //       i < 8 ? this.bg.y + height / 2.05 : this.bg.y + height / 1.78
  //     );
  //   }, this);

  //   const btnSize = this.bg.displayWidth / 3;
  //   const btnScale = localScaleManager.scaleSprite(
  //     this.runItTwiceBtn,
  //     btnSize,
  //     btnSize,
  //     0,
  //     1,
  //     true
  //   );
  //   const btnDeltaY = this.runItTwiceBtn.displayHeight * 1.2;
  //   const btnX = initX + width / 2;

  //   localScaleManager.scaleSpriteTo(this.quitBtn, btnScale);
  //   this.quitBtn.setPosition(
  //     btnX,
  //     this.bg.y + this.bg.displayHeight - this.runItTwiceBtn.displayHeight * 0.7
  //   );

  //   localScaleManager.scaleSpriteTo(this.runIt2Of3Btn, btnScale);
  //   this.runIt2Of3Btn.setPosition(btnX, this.quitBtn.y - btnDeltaY);

  //   localScaleManager.scaleSpriteTo(this.runIt3TimesBtn, btnScale);
  //   this.runIt3TimesBtn.setPosition(btnX, this.runIt2Of3Btn.y - btnDeltaY);

  //   localScaleManager.scaleSpriteTo(this.runItTwiceBtn, btnScale);
  //   this.runItTwiceBtn.setPosition(btnX, this.runIt3TimesBtn.y - btnDeltaY);

  //   const footerTextSize = this.bg.displayWidth * 0.85;
  //   localScaleManager.scaleBitMapText(
  //     this.footerText,
  //     footerTextSize,
  //     height * 0.05,
  //     0,
  //     1,
  //     false
  //   );
  //   this.footerText.setPosition(
  //     this.bg.x + width / 20,
  //     this.bg.y + height / 1.5
  //   );

  //   localScaleManager.scaleSpriteTo(this.acceptBtn, btnScale);
  //   this.acceptBtn.setPosition(
  //     btnX - this.acceptBtn.displayWidth / 1.8,
  //     this.bg.y + this.bg.displayHeight - this.acceptBtn.displayHeight * 2
  //   );

  //   localScaleManager.scaleSpriteTo(this.quit2Btn, btnScale);
  //   this.quit2Btn.setPosition(
  //     btnX + this.quit2Btn.displayWidth / 1.8,
  //     this.bg.y + this.bg.displayHeight - this.quit2Btn.displayHeight * 2
  //   );
  // }
}
